import { updateArray } from "../../../../../../utils/methods/validateArrays";
import { CheckUserPayload, NewError, NewUuId, StateLoad, StateLogbook, UserToAssignPayload, UserToAssignSelect } from "../types";

export const searchUsers = (state: StateLogbook, action: UserToAssignPayload): StateLogbook => {
    const { activityRegister } = state
    const { form } = activityRegister
    return { ...state, activityRegister: { ...activityRegister, form: { ...form, usersSearchs: action.value } } }
}

export const editUuId = (state: StateLogbook, action: NewUuId): StateLogbook => {
    const { uuidType, uuid } = action;
    return { ...state, uuid: { ...state.uuid, [uuidType]: uuid } }
}

export const editError = (state: StateLogbook, action: NewError): StateLogbook => {
    const { uuidType, error } = action;
    return { ...state, err: { ...state.err, [uuidType]: error } }
}

export const editLoadState = (state: StateLogbook, action: StateLoad): StateLogbook => {
    const { loadType, load } = action;
    return { ...state, loading: { ...state.loading, [loadType]: load } }
}

export const selectUser = (state: StateLogbook, action: UserToAssignSelect): StateLogbook => {
    const { activityRegister } = state
    const { form } = activityRegister
    const { userSelecteds } = form
    const existedUser = userSelecteds.includes(action.userId)
    return { ...state, activityRegister: { ...activityRegister, form: { ...form, userSelecteds: existedUser ? userSelecteds.filter(user => user != action.userId) : [...userSelecteds, action.userId] } } }
}

export const checkUser = (state: StateLogbook, action: CheckUserPayload): StateLogbook => {
    const { activityRegister, } = state
    const { usersChecks, usersUnChecks, activity: { userList } } = activityRegister
    const userListId: string[] = userList.map(user => user.id)
    const isTypeBoolean = typeof action.all == 'boolean'
    const { newArray } = updateArray({ newArray: action.ids, oldArray: usersChecks })
    const unCheck = updateArray({ newArray: action.ids, oldArray: usersUnChecks })
    let newUserCheck = newArray
    let newUserUnCheck = unCheck.newArray
    if (isTypeBoolean) {
        if (action.all) {
            newUserCheck = userListId
            newUserUnCheck = []
        }
        else {
            newUserCheck = []
            newUserUnCheck = userListId
        }
    }
    return {
        ...state,
        activityRegister: {
            ...activityRegister,
            usersChecks: newUserCheck,
            usersUnChecks: newUserUnCheck,
            ...isTypeBoolean && { allSelecteds: !!action.all }
        }
    }
}